import React from 'react'

const OptionValue = (props) => {
  return(
    <div className="Select-value" title={props.value.label}>
			<span className="Select-value-label">
        <i className={props.value.content.icon} aria-hidden="true"></i>
				{props.children}
			</span>
		</div>
  )
}

export default OptionValue;



/** WEBPACK FOOTER **
 ** ./src/components/pages/OptionValue.js
 **/